"use client";
import { WinnersContextProvider } from "@/contexts/winners";
import CategoriesContent from "./main";
import MainContent from "./main/main-content";
import { Categories } from "@/types/winners";
import Carpet from "../ui/Carpet";

type Props = {
  categories: Categories[];
};

export default function WinnersContent({ categories }: Props) {
  return (
    <WinnersContextProvider categories={categories}>
      <Carpet type="fade-light-to-dark" className="pb-32">
        <div className="flex pb-10 pt-16 sm:pb-14 sm:pt-40">
          <CategoriesContent />
        </div>
        <MainContent />
        <div className="pointer-events-none absolute -bottom-40 z-10 h-80 w-full bg-gradient-to-b from-transparent via-[#875ea5] to-transparent" />
      </Carpet>
    </WinnersContextProvider>
  );
}
